import { createFeatureSelector, createSelector } from '@ngrx/store'
import { MevoState } from './mevo.reducer'

export const selectMevoState = createFeatureSelector<MevoState>('mevo')
export const selectMevoValue = createSelector(
	selectMevoState,
	(state) => state.value
)

export const selectMevoId = createSelector(selectMevoState, (state) => state.id)
